<template>
    <div class="fiance-rechargecli">
        <div class="totle-content">
            <div class="select-search">
                <div class="select-group">
                    <!--<el-select v-model="value8" filterable placeholder="租客姓名">-->
                    <!--&lt;!&ndash;<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>&ndash;&gt;-->
                    <!--</el-select>-->
                    <!--<el-select v-model="value8" filterable placeholder="支付方式">-->
                    <!--&lt;!&ndash;<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>&ndash;&gt;-->
                    <!--</el-select>-->
                    <!--<el-date-picker v-model="date_value" type="daterange" align="right" unlink-panels-->
                    <!--range-separator="至"-->
                    <!--start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2"-->
                    <!--value-format="yyyy-MM-dd">-->
                    <!--</el-date-picker>-->
                </div>
                <div class="button-group">
                    <el-date-picker v-model="date_value" type="daterange" align="right" unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2"
                                    value-format="yyyy-MM-dd" @change="recharge()">
                    </el-date-picker>
                    <!--<el-button type="primary" icon="el-icon-search" @click="skip=0;limit=20;cur_page=1;recharge()">搜索</el-button>-->
                    <el-button type="success" icon="el-icon-tickets" @click="downloadMater">导出</el-button>
                </div>
            </div>

            <div class="table-content">
                <el-table class="table-head" :data="rechargeData" border style="width:100%">
                    <el-table-column align="center" type="index" min-width="50"></el-table-column>
                    <el-table-column align="center" prop="room" label="房间名" min-width="110" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="money" label="金额(元)" min-width="80" ></el-table-column>
                    <el-table-column align="center" prop="price" label="单价(元)" min-width="80" ></el-table-column>
                    <el-table-column align="center" prop="surplus" label="剩余电量" min-width="80"></el-table-column>
                    <el-table-column align="center" prop="address" label="房源详细地址" min-width="280" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="name" label="租客姓名" min-width="110" sortable></el-table-column>
                    <el-table-column align="center" prop="phone" label="电话" min-width="110"></el-table-column>
                    <el-table-column align="center" prop="way" label="充值方式" min-width="100"></el-table-column>
                    <el-table-column align="center" prop="reason" label="充值原因" min-width="100"></el-table-column>
                    <el-table-column align="center" prop="time" label="充值时间" min-width="110" sortable show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
            <!--分页-->
            <!--<div class="pagination-part">-->
                <!--<el-pagination-->
                        <!--@size-change="handleSizeChange"-->
                        <!--@current-change="handleCurrentChange"-->
                        <!--:current-page.sync="cur_page"-->
                        <!--:page-sizes="[10, 20, 50, 100]"-->
                        <!--:page-size="20"-->
                        <!--layout="total,sizes, prev, pager, next, jumper"-->
                        <!--:total="total">-->
                <!--</el-pagination>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    import store from "../store";
    var FileSaver = require('file-saver');

    export default {
        name: "FinanceRechargeCil",
        data() {
            return {
                pickerOptions2: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                date_value: [],
                rechargeData: [],
                total:0,
                skip:0,
                limit:-1,
                cur_page:1,

            };
        },
        mounted: function () {
            //初始获取最近一个月数据
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            end=store.getters.getNowFormatDate(end);
            start=store.getters.getNowFormatDate(start);
            this.date_value=[start,end];
            this.recharge();
        },
        methods: {
            //获取充值记录
            recharge() {
                var begin_date = this.date_value[0];
                var end_date = this.date_value[1];
                console.log(this.skip,this.limit,this.cur_page)
                this.$http.get(`${store.state.url}zone/order/authorized/`+this.skip+`/`+this.limit+`/` + begin_date + `/` + end_date + `?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            let Data = [];
                            if(res.Data!=null) {
                                for (let i in res.Data) {
                                    let reason="";
                                    if(res.Data[i].Reason=="\"\""){
                                        reason="";
                                    }else{
                                        reason=res.Data[i].Reason;
                                    }
                                    Data[i] = {
                                        room: res.Data[i].RoomName,
                                        money: res.Data[i].Money.toFixed(2),
                                        price: res.Data[i].Price.toFixed(2),
                                        surplus: res.Data[i].Surplus,
                                        address: res.Data[i].Addr,
                                        name: res.Data[i].TenantName,
                                        phone: res.Data[i].TenantPhone,
                                        way: res.Data[i].RechargeWay,
                                        reason: reason,
                                        time: res.Data[i].OperateTime,
                                    };
                                }
                            }
                            this.rechargeData = Data;
                            // this.total=res.Expand;
                        } else {
                            this.rechargeData =[];
                            // this.total=0;
                            this.$message(res.Message);
                        }
                    })
            },

            //分页
            handleSizeChange(val) {
                this.limit=val;
                this.recharge();
            },
            handleCurrentChange(val) {
                this.skip=(val-1)*this.limit;
                this.recharge();
            },

            //导出excel
            downloadMater (){
                const defaultCellStyle =  { font: { name: "Verdana", sz: 11, color: "FF00FF88"}, fill: {fgColor: {rgb: "FFFFAA00"}}};
                const wopts = { bookType:'xlsx', bookSST:false, type:'binary', defaultCellStyle: defaultCellStyle, showGridLines: false};
                const wb = { SheetNames: ['Sheet1'], Sheets: {}, Props: {} };

                let Data=[];
                for(let i in this.rechargeData){
                    Data[i] = {
                        房间名: this.rechargeData[i].room,
                        金额: this.rechargeData[i].money,
                        单价: this.rechargeData[i].price,
                        剩余电量: this.rechargeData[i].surplus,
                        房源详细地址: this.rechargeData[i].address,
                        租客姓名: this.rechargeData[i].name,
                        电话: this.rechargeData[i].phone,
                        充值时间: this.rechargeData[i].time,
                    };
                }
                let data = Data;
                wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

                //创建二进制对象写入转换好的字节流
                let tmpDown =  new Blob([this.s2ab(XLSX.write(wb, wopts))], { type: "application/octet-stream" })
                FileSaver.saveAs(tmpDown, "充值记录.xls");
            },
            //字符串转字符流
            s2ab (s) {
                if (typeof ArrayBuffer !== 'undefined') {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                } else {
                    var buf = new Array(s.length);
                    for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
            },

        }
    }
</script>

<style scoped>



</style>
